module.exports = "0x58F6B8D0A80E2c1a394d0C01445721C1B7df5139"


// WEBPACK FOOTER //
// ./src/contracts/PizzaParlor.1.address.js